module.exports = __webpack_public_path__ + "9f6e1c2d6757d6b743e21bb2201a2283.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new-realisations/plaisirs-gastronomiques2/03.jpg
// module id = FApU
// module chunks = 0